import * as Combobox from '@givebutter/primitives/combobox';
import { ContactType } from 'constants/contacts';

const ContactTypeOptions = () => {
    return (
        <>
            <Combobox.Item value={ContactType.Individual}>
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Individual</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value={ContactType.Company}>
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Company</Combobox.ItemText>
            </Combobox.Item>
        </>
    );
};

export { ContactTypeOptions };
